import { render } from "./InputProductList.vue?vue&type=template&id=3f2de5aa&ts=true"
import script from "./InputProductList.vue?vue&type=script&lang=ts"
export * from "./InputProductList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__